import dayjs from "dayjs"


const isNull = (value:any) => value === null
const isBoolean = (value:any) => /false|true/.test(value)
const isNumber = (value:any) => !isNaN(value)
const isDate = (value:any) => dayjs(value, "MM/DD/YYYY", true).isValid()
const isArray = (value:any) => Array.isArray(value) 
const isObject = (value:any) => !isArray(value) && typeof value === 'object'

const apiDataTypes = [
  "array",
  "boolean",
  "date",
  "null",
  "number",
  "object",
  "string",
]

function getDataType(value:any){
  let type;
  let hiddenType; 
  // console.log(`value: ${value}`)

  if( typeof value === "string"){
    // console.log(`${value} is a string`)
    type = "string"
    if( isNull(value) ) hiddenType = "null"
    if( !hiddenType && isBoolean(value) ) hiddenType = "boolean"
    if( !hiddenType && isNumber(value) ) hiddenType = "number"
    if( !hiddenType && isDate(value) ) hiddenType = "date"
    if( !hiddenType && isArray(value) ) hiddenType = "array"
    if( !hiddenType && isObject(value) ) hiddenType = "object"
    if( !hiddenType ) hiddenType = "string"
  } else {
    if( isNull(value) ) type = "null"
    if( !type && isBoolean(value) ) type = "boolean"
    if( !type && isNumber(value) ) type = "number"
    if( !type && isDate(value) ) type = "date"
    if( !type && isArray(value) ) type = "array"
    if( !type && isObject(value) ) type = "object"
    if( !type ) type = "string"
    hiddenType = type
  }
  return { type, hiddenType }
}


function isJson(str:string) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

const getUniqueObjByKey = (array:any[], key:string) => {
  return array.reduce((acc, item) => {
    if (!acc.some( (existing:any) => existing[key] === item[key])) {
      acc.push(item);
    }
    return acc;
  }, []);
};


export const inspect = {
  apiDataTypes,
  getDataType,
  getUniqueObjByKey,
  isJson
}